import { render, staticRenderFns } from "./AMLStatement.vue?vue&type=template&id=38bf601a&scoped=true&"
import script from "./AMLStatement.vue?vue&type=script&lang=js&"
export * from "./AMLStatement.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/AboutUs-pc.css?vue&type=style&index=0&id=38bf601a&scoped=true&lang=css&"
import style1 from "../assets/css/AboutUs-phone.css?vue&type=style&index=1&id=38bf601a&scoped=true&lang=css&"
import style2 from "./AMLStatement.vue?vue&type=style&index=2&id=38bf601a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf601a",
  null
  
)

export default component.exports